import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Campaign } from '../../../../../../models/campaign.model';
import { Creator } from '../../../../../../models/creator.model';
import { Privilege } from '../../../../../../models/role.model';
import { Submission } from '../../../../../../models/submission.model';
import { CampaignService } from '../../../../../../services/campaign.service';
import { SubmissionService } from '../../../../../../services/submission.service';
import { UserService } from '../../../../../../services/user.service';
import { SubmissionDialogComponent } from '../../submission-dialog.component';
import { CreatorApproval } from 'src/app/models/CreatorApproval.model';

@Component({
  selector: 'app-social-youtube-content',
  templateUrl: './youtube-content.component.html',
  styleUrls: ['./youtube-content.component.css']
})
export class YoutubeContentComponent implements OnInit {

  @Input() public submission: Submission;
  @Input() public creator: Creator;
  @Input() public campaign: Campaign;
  @Input() public creatorApproval: CreatorApproval;
  @Output() public editMode: EventEmitter<Submission> = new EventEmitter<Submission>();
  @Output() public error: EventEmitter<string> = new EventEmitter<string>();
  public status: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  public safeVideo: SafeResourceUrl;
  public posting: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(undefined);
  public previewUrl: BehaviorSubject<string | ArrayBuffer> = new BehaviorSubject(undefined);
  public userHasPrivileges: BehaviorSubject<boolean> = new BehaviorSubject(undefined);
  public isEditing: BehaviorSubject<boolean> = new BehaviorSubject(undefined);
  public editing: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(undefined);
  public caption: string;
  public submissions: Submission[];

  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly userService: UserService,
    public dialogRef: MatDialogRef<SubmissionDialogComponent>,
    private readonly submissionService: SubmissionService) {
  }

  public ngOnInit(): void {
    this.status.next(this.submission.status);
    this.caption = this.submission.captions;
    this.setVideoUrl();
    this.userHasPrivileges.next(this.userService.hasPrivileges(
      [Privilege.PREDEFINED.EDIT_CONTENT], this.campaign.companyId, this.campaign.brandId, this.campaign.id));
    this.setVideoUrl();
  }

  public setVideoUrl(): void {
    if (this.isYoutube()) {
      const videoId = this.submission.video.split('/').pop();
      this.safeVideo = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + videoId);
    } else {
      this.safeVideo = this.sanitizer.bypassSecurityTrustResourceUrl(this.submission.video);
    }
  }

  private isYoutube(): boolean {
    return !!this.submission.video && this.submission.video.includes('youtube');
  }

  public enableEditMode(): void {
    this.isEditing.next(true);
    this.editMode.emit(this.submission);
  }

  public saveEdit(): void {
    this.posting.next(true);
    this.submission.captions = this.caption;
    this.submissionService.editSubmission(this.submission)
    .pipe(
      finalize(() => {
        this.posting.next(false);
        this.dialogRef.close();
      }))
        .subscribe({
            next: (value: any) => {
              this.submissions = value.submissions.map(value => new Submission().deserialize(value));
                if (this.submission.mediaFile && this.submission.mediaFile.type.includes('video')) {
                  this.submissionService.uploadVideo(value.upload, this.submission.mediaFile)
                    .subscribe({
                      error: (error: HttpErrorResponse) => {
                        console.log(error);
                      }
                    });
                }
            }, error: (error: HttpErrorResponse) => {
              console.log(error);
          }});
  }

  public cancelEdit(): void {
    this.editMode.emit(this.submission);
    this.previewUrl.next(undefined);
    this.isEditing.next(false);
  }

  public handleFileInput(files: FileList): void {
    const file = this.submission.mediaFile = files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.previewUrl.next((<FileReader>event.target).result);
        this.saveEdit();
      };
    }
  }

  onUploadClick() {
    document.getElementById('uploadFile').click();
  }


  public delete(): void {
    this.posting.next(true);
    this.submissionService.deleteSubmission(this.submission)
    .pipe(
      finalize(() => {
        this.posting.next(false);
        this.dialogRef.close(this.submissions);
      }))
        .subscribe({
            next: (value: any) => {
              this.submissions = value.submissions.map(value => new Submission().deserialize(value));
            }, error:  (error: HttpErrorResponse) => {
              this.error.emit(error.message);
            }
        });
  }


}
